import { useMemo } from "react";
import { I18nextProvider } from "react-i18next";

import { initI18n } from "@punto/frontend-shared/i18n/i18n";

export const I18nProvider = ({
  children,
  buildVersion,
}: {
  children?: React.ReactNode;
  buildVersion: string;
}) => {
  const i18n = useMemo(() => {
    return initI18n(buildVersion);
  }, [buildVersion]);

  return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
};
